import { Show, For, Switch, Match, createContext, createEffect, createMemo, createSignal, useContext, Signal } from "solid-js";
import styles from './k12-hallpass-stuhallpasses.module.css'
import { requireViewContext, Icon, Loader } from "st-app";
import { k12HallpassStuhallpasses as api, StudentHallPassesData, StuHallPassData } from 'sis-app/api';

class K12HallpassStuhallpassesContext {

}

class K12HallpassStuhallpassesProps {
    context?: K12HallpassStuhallpassesContext
    ssyGU: string = ""
    overLimitFilterActive?: Signal<boolean>
    showMorePasses?: Signal<boolean>
    timeFrame?: Signal<string>
    svue: boolean = false
}

const k12HallpassStuhallpassesContext = createContext(new K12HallpassStuhallpassesContext());
export const useK12HallpassStuhallpassesContext = () => useContext(k12HallpassStuhallpassesContext);

export default function K12HallpassStuhallpasses(props: K12HallpassStuhallpassesProps) {
    const context = createMemo(() => props.context || new K12HallpassStuhallpassesContext());

    return <k12HallpassStuhallpassesContext.Provider value={context()}>
        <K12HallpassStuhallpassesInner {...props} />
    </k12HallpassStuhallpassesContext.Provider>
}
K12HallpassStuhallpasses.defaultProps = new K12HallpassStuhallpassesProps();

function K12HallpassStuhallpassesInner(props: K12HallpassStuhallpassesProps) {
    const [hallpassData, setHallpassData] = createSignal<StudentHallPassesData | undefined>();
    const [overLimitFilterActive, setOverLimitFilterActive] = props.overLimitFilterActive ?? createSignal<boolean>();
    const [showMorePasses, setShowMorePasses] = props.showMorePasses ?? createSignal<boolean>();
    const [timeFrame, setTimeFrame] = props.timeFrame ?? createSignal<string>();

    createEffect(() => { 
        setHallpassData(undefined);
        if (props.ssyGU) {
            api.LoadData(props.ssyGU, overLimitFilterActive() ?? false, showMorePasses() ?? false, timeFrame() ?? "", props.svue)
                .then((data) => {
                    setHallpassData(data);
                });
        }
    });

    return <div class={styles.studentHallPassesData}>
        <Switch>
            <Match when={hallpassData()?.hasData === true}>
                <div>
                    <For each={hallpassData()?.inProgressPasses ?? []}>{pass =>
                        <Hallpass pass={pass} />
                    }</For>
                </div>
                <div>
                    <For each={hallpassData()?.passes ?? []}>{pass =>
                        <Hallpass pass={pass} />
                    }</For>
                </div>
            </Match>
            <Match when={hallpassData()?.hasData == false}>
                <div class={styles.noData}>
                    <span class={styles.noDataMsg}>No Hall Passes</span>
                </div>
            </Match>
            <Match when={props.ssyGU}>
                <Loader />
            </Match>
        </Switch>
    </div>
}

function Hallpass(props: { pass: StuHallPassData }) {
    const pass = props?.pass ?? {};
    const room = pass.room ?? {};

    return <div
        class={styles.studentHallPass}
        style={{
            'background-color': room.colorLight ?? '#fff'
        }}
    >
        <span><img class={styles.roomIcon} src={room.iconPath} alt={room.roomName} ></img></span>
        <span class={styles.roomName}>{room.roomName}</span>
        <span>{pass.dateTime}</span>
        <div class={styles.totalTime} style={{ 'background-color': pass.overTimeLimit ? 'red' : room.color ?? '#fff' }} >
            <Show when={pass.overTimeLimit}>
                <div class={styles.overLimitIcon}><Icon src="fa-regular fa-triangle-exclamation"></Icon></div>
            </Show>

            <Switch>
                <Match when={pass.inProgress}>
                    <span>In Progress</span>
                </Match>
                <Match when={!pass.inProgress}>
                    <span class={styles.totalTimeValue}> {pass.totalTime}</span>
                </Match>
            </Switch>
        </div>
    </div>
}